import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import CorporationHometaxAuthContent from '@/components/tax-refund/corporation/HometaxAuth/CorporationHometaxAuthContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const CorpationHometaxAuthPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증정보입력, 'corps-hometax_cx_top-right');

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'corps-hometax'} eventName={'corps-hometax_login'}>
        <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'corps-hometax_topnav_back' } }} rightTextButton={rightInquiryButton}>
          <CorporationHometaxAuthContent />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default CorpationHometaxAuthPage;
